import 'sticksy'

export default () => {
	// var stickyElement = new Sticksy('.js-sticky-widget');
	let stickies = document.getElementsByClassName('js-sticky-widget');
	let headerHeight = document.getElementById('header').clientHeight + 30;
	let pageContent = document.getElementsByClassName('page-content');
	pageContent = pageContent.length ? pageContent[0] : null;
	let programModule = document.getElementsByClassName('module--program');
	programModule = programModule.length ? programModule[0] : null;

	function getAbsPosition(element) {
		var rect = element.getBoundingClientRect();
		return { x:rect.left, y:rect.top }
	}

	function getElementOffset(el) {
		let top = 0;
		let left = 0;
		let element = el;
	  
		// Loop through the DOM tree
		// and add it's parent's offset to get page offset
		do {
		  top += element.offsetTop || 0;
		  left += element.offsetLeft || 0;
		  element = element.offsetParent;
		} while (element);
	  
		return {
		  top,
		  left,
		};
	}
	
	if(stickies.length)
	{
		window.addEventListener('scroll', function(e) {
			for (let i = 0; i < stickies.length; i++) {
				const el = stickies[i];
				if(window.scrollY > getElementOffset(el).top - headerHeight && window.scrollY > getElementOffset(pageContent).top - headerHeight && window.scrollY < getElementOffset(pageContent).top + pageContent.clientHeight - headerHeight - el.clientHeight - (programModule !== null ? programModule.clientHeight : 0))
				{
					el.classList.add("sticky");
				} else 
				{
					el.classList.remove("sticky");
				}
			}
		});
	}
};